export default __webpack_public_path__ + "static/media/Profs-background.b30fbed4.svg";